export enum LocalStorageNames {
    language = 'language',
    newPersonForm = 'newPersonForm',
    userGuid = 'userGuid',
    countries = 'countries',
    provinces = 'provinces'
}
